export const initializePageTransitionLoader = () => {
  const loader = document.querySelector("[data-page-transition-loader]");
  if (!loader) return;

  const storageKey = "squra.pageLoaderStartedAt";
  const minimumDuration = 650;
  let fallbackTimer;

  const readStartedAt = () => {
    try {
      return Number(window.sessionStorage.getItem(storageKey)) || 0;
    } catch {
      return 0;
    }
  };

  const rememberStart = () => {
    try {
      window.sessionStorage.setItem(storageKey, String(Date.now()));
    } catch {
      // Storage is optional; the loader still works without it.
    }
  };

  const clearStart = () => {
    try {
      window.sessionStorage.removeItem(storageKey);
    } catch {
      // Storage is optional.
    }
  };

  const hideLoader = () => {
    window.clearTimeout(fallbackTimer);
    loader.classList.remove("is-active");
    loader.setAttribute("aria-hidden", "true");
    clearStart();
  };

  const showLoader = () => {
    window.clearTimeout(fallbackTimer);
    rememberStart();
    loader.classList.add("is-active");
    loader.setAttribute("aria-hidden", "false");
    fallbackTimer = window.setTimeout(hideLoader, 10000);
  };

  const settleLoader = () => {
    const elapsed = readStartedAt()
      ? Date.now() - readStartedAt()
      : minimumDuration;
    const remaining = Math.max(0, minimumDuration - elapsed);

    if (remaining > 0) {
      loader.classList.add("is-active");
      loader.setAttribute("aria-hidden", "false");
      window.setTimeout(hideLoader, remaining);
      return;
    }

    hideLoader();
  };

  document.addEventListener("click", (event) => {
    const link = event.target.closest("a[href]");
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
      return;
    if (
      link.hasAttribute("download") ||
      link.dataset.noPageLoader !== undefined
    )
      return;
    if (link.target && link.target.toLowerCase() !== "_self") return;

    const href = link.getAttribute("href");
    if (!href || href === "#" || href.startsWith("javascript:")) return;
    if (href.startsWith("mailto:") || href.startsWith("tel:")) return;

    const destination = new URL(link.href, window.location.href);
    const sameDocument =
      destination.origin === window.location.origin &&
      destination.pathname === window.location.pathname &&
      destination.search === window.location.search;

    if (!(sameDocument && destination.hash)) queueMicrotask(showLoader);
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.checkValidity()) return;
    if (
      form.method.toLowerCase() === "dialog" ||
      form.dataset.noPageLoader !== undefined
    )
      return;
    queueMicrotask(showLoader);
  });

  window.addEventListener("beforeunload", showLoader);
  window.addEventListener("pageshow", settleLoader);
  document.addEventListener("DOMContentLoaded", settleLoader);
};
